import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { StateParaService } from '../reports/stateparameter/stateparameter-para.service';
import { PrintService } from '../print-layout/print.service';

@Component({
  selector: 'app-medicallicensereportbystatelink',
  templateUrl: './medicallicensereportbystatelink.component.html',
  styleUrls: ['./medicallicensereportbystatelink.component.scss']
})
export class MedicallicensereportbystatelinkComponent implements OnInit {
  rowIds: string[];
  rowDetails: Promise<any>[];
  rowId:number;
  statename:string;
  print:string;

  constructor(private route: ActivatedRoute, private stateParaService:StateParaService,
        private printService: PrintService, private http: HttpClient) {           
        this.rowIds = route.snapshot.params['Id']
        .split(',');
        this.rowId = +this.rowIds[0];
        // this.print= String(this.rowIds[1]);
        }

  ngOnInit() {
    
    this.stateParaService.getRecruitsMediclalicensesbystate(this.rowId).subscribe(success =>{
      if(success) {
        this.stateParaService.mediclalicensesbystatelist =  this.stateParaService.mediclalicensesbystatelist;
        
        // console.log( this.stateParaService.mediclalicensesbystatelist );
      }
      
    });
  

   }

}
